import type { JobSearchConstraints } from "@tabbio/types";
import type { CVJobPreferences } from "./cv-mock-data";

/** Validate before JSON serialization, which would silently turn NaN into null. */
export function hasValidJobSearchConstraints(
  value: JobSearchConstraints,
): boolean {
  if (
    value.minimumSalary != null &&
    (!Number.isFinite(value.minimumSalary) ||
      value.minimumSalary < 0 ||
      value.minimumSalary > 100000000 ||
      !/^[A-Z]{3}$/.test(value.salaryCurrency ?? ""))
  )
    return false;
  return (
    (["cities", "excludedRoles", "excludedCompanies"] as const).every((key) => {
      const values = value[key] ?? [];
      return (
        values.length <= (key === "cities" ? 20 : 30) &&
        values.every(
          (item) =>
            item.trim().length > 0 &&
            item.length <= (key === "cities" ? 100 : 120),
        )
      );
    }) && (value.countries?.length ?? 0) <= 20
  );
}

/**
 * How many of the preferences the Job Preferences form tucks under "More
 * preferences" carry a value, so the collapsed row can say something is set
 * inside it. Shared by the web and native forms.
 */
export function countMoreJobPreferences(prefs: CVJobPreferences): number {
  return [
    (prefs.cities?.length ?? 0) > 0,
    (prefs.excludedRoles?.length ?? 0) > 0,
    (prefs.excludedCompanies?.length ?? 0) > 0,
    (prefs.seniorityLevels?.length ?? 0) > 0,
    prefs.minimumSalary != null,
    !!prefs.relocation,
    (prefs.relocationAreas?.length ?? 0) > 0,
    !!prefs.noticePeriod,
  ].filter(Boolean).length;
}
